import React, { useEffect } from "react";
import CustomInput from "../../../Components/Atoms/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { Autocomplete, TextField } from "@mui/material";
import CustomSelect from "../../../Components/Atoms/CustomSelect";
import { MASTER_SETTINGS } from "../../../Constant";
import { getMasterListRequest } from "../../../Redux/Master/MasterActions";

const VisitorHostInformation = ({ formik, type }) => {
  const { getMasterListResponse } = useSelector((state) => state.masterReducer);
  return (
    <>
      <div className="col-md-12 pt-0">
        <h6 className="mb-4">Host Details</h6>
      </div>
      <>
        <div className="col-md-4">
          <div className="d-flex">
            <p className="mb-1">Host Department</p>
            <p className="erroStar">*</p>
          </div>
          <CustomSelect
            type="text"
            name="host_details.host_department"
            placeholder="SELECT HOST DEPARTMENT"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.host_details?.host_department}
            formik={formik}
            data={getMasterListResponse?.data?.filter(
              (e) =>
                e.type === MASTER_SETTINGS.HOST_DEPARTMENT &&
                e.status === "ACTIVE"
            )}
            setValue="_id"
            errorMsg={
              formik.touched?.host_details?.host_department &&
              formik.errors?.host_details?.host_department
            }
          />
        </div>
        <div className="col-md-4">
          <CustomInput
            label="Host Name"
            name="host_details.host_name"
            upperLabel={true}
            placeholder="Enter host name"
            value={formik.values.host_details?.host_name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            formik={formik}
          />
        </div>
        <div className="col-md-4">
          <CustomInput
            label="Host Contact No"
            name="host_details.host_contact_no"
            type={"number"}
            upperLabel={true}
            placeholder="Enter host contact no"
            value={formik.values.host_details?.host_contact_no}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            formik={formik}
          />
        </div>
      </>
    </>
  );
};

export default VisitorHostInformation;
